import { Image, StyleSheet, TouchableOpacity, View, useWindowDimensions } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { useDispatch, useSelector } from "react-redux"; 
import BottomSheetModal from "components/BottomSheetModal";
import { Colors } from "colors";
import VText from "components/VText";
import Svg, { Circle, Path } from "react-native-svg";
import { ActivityIndicator } from "react-native";
import { getSimilarProducts } from "src/redux/reducers/chatSlice";
import { Link } from "expo-router";


export default React.forwardRef(({product,replaceProduct,setReplaceProduct,replacedProduct,setReplacedProduct}, ref) => {
    const { height, width } = useWindowDimensions();
    const _bottomSheetRef = useRef();
    const [similarProducts, setSimilarProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    React.useImperativeHandle(ref, () => ({ show, hide }), []);
    const dispatch = useDispatch();
    // const [selectedProduct, setSelectedProduct] = useState(null);

    const show = () => { _bottomSheetRef?.current?.show();};
    const hide = () => { _bottomSheetRef?.current?. hide();};

    useEffect(() => {
        if(product?.id){
        setIsLoading(true);
        dispatch(getSimilarProducts({productId: product?.id})).then((res) => {
            setIsLoading(false);
            setSimilarProducts(res.payload.data);
        });
        }
    }, [product?.id]);


    const renderSimilarProducts = (product) => {
        return (
            <TouchableOpacity onPress={() => {
              setReplacedProduct(product);
            }} style={{ width:wp(210),padding:wp(3),borderWidth:replacedProduct?.id === product?.id ? 1 : 0,borderColor:"black",borderRadius:wp(2),overflow:"hidden"}}>
                <Image source={{uri:product?.imageUrls[0]}} style={{width:wp(210), height:hp(300)}} />
                <View style={{paddingTop:spH(10),paddingBottom:spH(10)}}>
                    <VText style={{fontSize:fp(14), fontWeight:"600", color:Colors.black,marginBottom:spH(5)}}>{product?.brandName}</VText>
                    <VText numberOfLines={2} style={{ marginBottom:spH(5)}}>{product?.productName.slice(0, 20)}...</VText>
                    <VText>${product?.productPrice}</VText>
                </View>
            </TouchableOpacity>
        );
    }

    

    return (<View style={{flex:1, justifyContent:"center", alignItems:"center",minHeight:hp(700),paddingHorizontal:spH(40)}}>
            {isLoading 
                        ? (<ActivityIndicator size="large" color={Colors.primary} />) 
                        : (
                            <View style={{flexDirection:"row", alignItems:"center", gap:spH(15), flexWrap:"wrap" }}>
                                    {similarProducts.length > 0 ? (
                                        similarProducts.map((product) => (
                                            renderSimilarProducts(product)
                                        ))
                                    ) : (
                                        <VText>No similar products found</VText>
                                    )}
                                </View>
                            )}
          
            </View>);
});

const styles = StyleSheet.create({
    container: {
        backgroundColor: Colors.white,
        borderRadius: 8,
        width: wp(309),
    },
    image: {
        width: wp(309),
        height: hp(199),
    },
});
